import { Component } from '@angular/core';

@Component({
  selector: 'app-cer-add-page',
  templateUrl: './cer-add-page.component.html',
  styleUrls: ['./cer-add-page.component.scss'],
})
export class CerAddPageComponent {}
